import theme_icons from "../../icons.js";
import screenshot from "./screenshot.png";

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { InspectorControls } = wp.blockEditor;
const { PanelBody, SelectControl, RangeControl, CheckboxControl } = wp.components;
const { useSelect } = wp.data;

const allcategorylist = {
    title: 'All Category Index',
    icon: theme_icons.greenheart,
    category: 'greenheart',
    //attributes
    attributes: {
        postType: {
            type: 'string',
            default: ''
        },
        postCount: {
            type: 'integer',
            default: ''
        },
        categories: {
            type: 'array',
            default: []
        },
        ignoreCount: {
            type: 'integer',
            default: 0
        }
    },

    edit({ attributes, setAttributes }) {
        const { postType, postCount, categories, ignoreCount } = attributes;
        const categoriesList = useSelect(
            (select) =>
                select("core").getEntityRecords("taxonomy", "category", {
                    per_page: -1,
                }),
            []
        );

        return ([
            <InspectorControls>
                <PanelBody title={"All Category Index Settings"}>
                    <p>Post Type</p>
                    <SelectControl
                        label="Select Post Type"
                        value={postType}
                        options={[
                            { label: "Please Select", value: "" },
                            { label: "Posts", value: "post" },
                        ]}
                        onChange={(val) => setAttributes({ postType: val })}
                    />
                    <p>Post Count</p>
                    <RangeControl
                        label="Number of Posts to Display"
                        value={postCount}
                        onChange={(value) => setAttributes({ postCount: value })}
                        min={2}
                        max={10}
                    />

                    <p>Ignore Posts?</p>
                    <RangeControl
                        label="Ignore the most recent ___ posts (useful for offsetting from a Latest Posts block)"
                        value={ignoreCount}
                        onChange={(value) => setAttributes({ ignoreCount: value })}
                        min={0}
                        max={10}
                    />

                    <p>Select Categories</p>
                    {categoriesList &&
                        categoriesList.map((cat) => (
                            <CheckboxControl
                                key={cat.id}
                                label={cat.name}
                                checked={categories.includes(cat.id)}
                                onChange={(checked) => {
                                    const newSelection = checked
                                        ? [...categories, cat.id]
                                        : categories.filter((id) => id !== cat.id);

                                    setAttributes({ categories: newSelection });
                                }}
                            />
                        ))
                    }
                </PanelBody>
            </InspectorControls>,
            <div className="rbt-allCategoryList">
                <h4>All Category List</h4>
                <p>Example:</p>
                <img src={screenshot} alt="All Category List Preview" />
            </div>
        ]);
    },
    save({ attributes }) { return null; }
};
registerBlockType('rbt/allcategorylist', allcategorylist);
export default allcategorylist;
